/**
 * Règles : au moins 6 caractères, avec minuscule, majuscule, chiffre et caractère spécial.
 * Les caractères spéciaux acceptés : ! @ # $ % ^ & * ( ) _ + - = [ ] { } | ; : , . < > ? / ` ~
 */
const SPECIAL_RE = /[!@#$%^&*()_+\-=\[\]{}|;:,.<>/?`~]/;

export const PASSWORD_POLICY_HINT =
  "Au moins 6 caractères, avec une minuscule, une majuscule, un chiffre et un caractère spécial (!@#$%…).";

/**
 * @param {string} password
 * @returns {{ valid: boolean; message?: string }}
 */
export function validatePasswordStrength(password) {
  if (typeof password !== "string") {
    return { valid: false, message: "Le mot de passe est requis." };
  }
  if (password.length < 6) {
    return {
      valid: false,
      message:
        "Le mot de passe doit contenir au moins 6 caractères, avec minuscule, majuscule, chiffre et caractère spécial.",
    };
  }
  if (!/[a-z]/.test(password)) {
    return {
      valid: false,
      message: "Le mot de passe doit contenir au moins une lettre minuscule.",
    };
  }
  if (!/[A-Z]/.test(password)) {
    return {
      valid: false,
      message: "Le mot de passe doit contenir au moins une lettre majuscule.",
    };
  }
  if (!/\d/.test(password)) {
    return {
      valid: false,
      message: "Le mot de passe doit contenir au moins un chiffre.",
    };
  }
  if (!SPECIAL_RE.test(password)) {
    return {
      valid: false,
      message:
        "Le mot de passe doit contenir au moins un caractère spécial (!@#$%^&*…).",
    };
  }
  return { valid: true };
}
